/* eslint-disable react/no-danger */
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import styles from '../../styles.module.scss';
import { Button } from '../../../../../components';
import classes from '../../../../../images/home/programTypeIcons/Classes.svg';
import clinic from '../../../../../images/home/programTypeIcons/Clinic.svg';
import dropin from '../../../../../images/home/programTypeIcons/Drop-In.svg';
import league from '../../../../../images/home/programTypeIcons/Leagues.svg';
import pickup from '../../../../../images/home/programTypeIcons/Pick-Up.svg';
import practice from '../../../../../images/home/programTypeIcons/Practice.svg';
import series from '../../../../../images/home/programTypeIcons/Series.svg';
import tournament from '../../../../../images/home/programTypeIcons/Tournaments.svg';
import { SportDetailsProps } from '../../../../../types';
import { upperFirst } from '../../../../../shared/string-manipulations';

import Picture from '../../../../../components/Picture/Picture';

const cx = classNames.bind(styles);

const SportProgramTypes = props => {
  const {
    chosenCity,
    chosenSport,
    homepageDefaults: { programDescriptions, programImages },
    sportDetails: { programTypes },
    upcomingProgramTypes,
  } = props;

  const activeProgramTypes =
    (programTypes || []).filter(
      t => upcomingProgramTypes.includes(upperFirst(t.name)) || !t.hide
    ) || [];

  const [whichDo, setWhichDo] = useState(activeProgramTypes[0]?.name);

  const programTypeIcons = {
    dropin,
    league,
    pickup,
    practice,
    tournament,
    clinic,
    series,
    class: classes,
  };

  return activeProgramTypes.length ? (
    <div className={cx('multiPanels', 'container')}>
      <h1 className={cx('fancyText', 'mb-4')}>Program Types</h1>
      <div className={cx('programTabs')}>
        {activeProgramTypes.map(({ name = '' }) => (
          <div
            key={name}
            onClick={() => setWhichDo(name)}
            role="button"
            className={cx('col-md-3 col-6 p-0')}
            tabIndex={0}
          >
            <div className={cx('programTab', whichDo === name && 'active')}>
              {programTypeIcons[name] && (
                <img src={programTypeIcons[name]} alt="volo leagues icon" />
              )}
              <h4>{name}</h4>
            </div>
          </div>
        ))}
      </div>
      <div className={cx('descriptionBlock', 'row')}>
        <div className="col-12 col-md-7">
          {activeProgramTypes.map(
            ({ name = '', description = {} }, i) =>
              whichDo === name && (
                <div key={`program-${i + 1}`} className={cx('descriptionCard')}>
                  <h2>
                    {chosenSport} {name[name.length - 1] === 's' ? `${name}es` : `${name}s`}
                  </h2>
                  <div
                    className={cx('info')}
                    dangerouslySetInnerHTML={{
                      __html:
                        (description.isCustom && description.text) || programDescriptions[name],
                    }}
                  />
                  <Link
                    to={{
                      pathname: '/discover',
                      search: `?cityName=${chosenCity}&sportNames[]=${chosenSport}`,
                    }}
                  >
                    <Button className={cx('yellowButton', 'mt-4', 'w-75')}>
                      Find {chosenSport} {name[name.length - 1] === 's' ? `${name}es` : `${name}s`}
                    </Button>
                  </Link>
                </div>
              )
          )}
        </div>
        <div className="col-12 col-md-5">
          {activeProgramTypes.map(({ name, programImage }) => {
            if (whichDo !== name) return <div key={name} />;
            let image;
            if (programImage?.url) {
              image = (
                <Picture
                  className={cx('programImage')}
                  key={name}
                  src={programImage.url}
                  alt={name}
                />
              );
            } else {
              image = (
                <img
                  className={cx('programImage')}
                  key={name}
                  src={programImages[name]}
                  alt={name}
                />
              );
            }
            return image;
          })}
        </div>
      </div>
    </div>
  ) : (
    <div />
  );
};

SportProgramTypes.propTypes = {
  chosenCity: PropTypes.string.isRequired,
  chosenSport: PropTypes.string.isRequired,
  sportDetails: SportDetailsProps.isRequired,
  homepageDefaults: PropTypes.shape({
    programDescriptions: PropTypes.shape({}),
    programImages: PropTypes.shape({}),
  }).isRequired,
  upcomingProgramTypes: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default SportProgramTypes;
